import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import secureLocalStorage from 'react-secure-storage';
import DatePicker from '../pages/DatePicker';
import TimePicker from '../pages/TimePicker';
import { useTranslation } from 'react-i18next';
import Btn_loader from '../Btn_loader';
const Signup = () => {

    const { t } = useTranslation();
    const { setIsToast, setToastMsg, setUserLogin, setIsAuth, HandleCallApi } = useContext(MyContext);

    const [step, setStep] = useState(1);
    const [alldata, setAllData] = useState({ name: "", email: "", password: "", gender: "Male", birthdate: dayjs(), birthtime: dayjs(), birthplace: "" });
    const [number, setNumber] = useState("");
    const [passtype, setPassType] = useState("Password");
    const [apiloading, setApiLoading] = useState("");;
    const [otpfiled, setOtpFiled] = useState(Array(6).fill(""));
    const [sendotp, setSendOtp] = useState("");
    const [smsType, setSmsType] = useState("");
    const [isdate, setIsDate] = useState(false);
    const [istime, setIsTime] = useState(false);
    const [languagelist, setLanguageList] = useState([]);
    const [selectlang, setSelectLang] = useState([]);
    const [searchlang, setSearchLang] = useState("");
    const [showCcode, setShowCcode] = useState(false);
    const [searchCcode, setSearchCcode] = useState("");
    const [selectCcode, setSelectCcode] = useState("+91");

    const GenderList = [{ title: "Male", icon: require("../../image/male.png") }, { title: "Female", icon: require("../../image/female.png") }];

    const OtpRef = useRef(Array.from({ length: 6 }, () => null));

    const navigate = useNavigate();

    const FilterLang = searchlang ? languagelist?.filter(item => item.title.toLowerCase().includes(searchlang.toLowerCase())) : languagelist;
    const countries = getCountries();
    const FilterCCode = countries.filter((item) => getCountryCallingCode(item).toString().includes(searchCcode));

    useEffect(() => {
        handleGetLanguageList();
    }, []);

    const ccodeRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ccodeRef.current && !ccodeRef.current.contains(event.target)) {
                setShowCcode(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleNext = () => {

        if (step === 1) {
            const { name, email, password } = alldata;

            if (!name || !email || !number || !password) {
                setIsToast(true);
                setToastMsg("Please enter all details !!");
                return;
            }

            const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
            if (!emailValidation.test(email)) {
                setIsToast(true);
                setToastMsg("Please enter valid email !!");
                return;
            }

            handleCheckNumber(email);
            return;
        }

        if (step === 2) {

            if (sendotp === otpfiled.join("")) {
                setStep(step + 1);
            } else {
                setIsToast(true);
                setToastMsg("In Valid OTP !!");
            }
            return;
        }

        if (step === 4) {
            const { birthplace } = alldata;
            if (!birthplace) {
                setIsToast(true);
                setToastMsg("Please enter birth place !!");
                return;
            }
        }


        if (step === 5) {
            if (selectlang.length <= 0) {
                setIsToast(true);
                setToastMsg("Please select language !!");
                return;
            }
            handleSignup();
            return;
        }

        setStep(step + 1);

    }

    const handleCheckNumber = async (email) => {

        setApiLoading("Next");

        const ApiData = {
            c_code: selectCcode,
            phone: number,
            email
        }

        const Response = await HandleCallApi("Post", "user/detail_check", ApiData);
        const { ResponseCode, number_result, email_result, message } = Response.data;

        if (ResponseCode === 200) {

            if (number_result === false || email_result === false) {
                setIsToast(true);
                setToastMsg(message);
                setApiLoading("");
                return;
            }

            if (number_result === true && email_result === true) {
                const Response = await HandleCallApi("Get", "user/otp_detail");
                const { ResponseCode, message } = Response.data;
                if (ResponseCode === 200) {
                    setSmsType(message);
                    if (message === "MSG91") {
                        handleMSG91(selectCcode, number);
                    } else if (message === "Twilio") {
                        handleTwilio(selectCcode, number);
                    } else if (message === "No Auth") {
                        setStep(3);
                        setApiLoading("");
                    }
                    return;
                }
                setApiLoading("");
            }
        }

        setApiLoading("");
    }

    const handleMSG91 = async (c_code, phone) => {
        const Response = await HandleCallApi("Post", "user/msg91", { c_code, phone });
        const { ResponseCode, message, otp } = Response.data;
        if (ResponseCode === 200) {
            setIsToast(true);
            setToastMsg(message);
            setOtpFiled(otp.toString().split(""));
            setStep(step + 1);
            setSendOtp(otp);
        }
        setApiLoading("");
    }

    const handleTwilio = async (c_code, phone) => {
        const Response = await HandleCallApi("Post", "user/twilio", { c_code, phone });
        const { ResponseCode, message, otp } = Response.data;
        if (ResponseCode === 200) {
            setIsToast(true);
            setToastMsg(message);
            setOtpFiled(otp.toString().split(""));
            setStep(step + 1);
            setSendOtp(otp);
        }
        setApiLoading("");
    }

    const handleOnChnage = (value, index) => {
        const Copy = [...otpfiled]
        Copy[index] = value;
        setOtpFiled(Copy)
        if (value && !isNaN(value) && index < OtpRef.current.length - 1) {
            OtpRef.current[index + 1].focus();
        }
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            OtpRef.current[index - 1].focus();
        }
    }

    const handleDateChange = (newDate) => {
        setAllData({ ...alldata, birthdate: newDate });
    };

    const handleTimeSelect = (newTime) => {
        setAllData({ ...alldata, birthtime: newTime });
    }

    const handleGetLanguageList = async () => {
        const Response = await HandleCallApi("Post", "user/language_list", { language: "" });
        setLanguageList(Response.data.language_list);
    }

    const handleSelectLanguage = (id) => {
        if (selectlang.includes(id)) {
            const Filterid = selectlang.filter(item => item !== id);
            setSelectLang(Filterid);
        } else {
            setSelectLang(prev => [...prev, id]);
        }
    }

    const handleSignup = async () => {
        const { name, email, password, gender, birthdate, birthtime, birthplace } = alldata;

        const ApiData = {
            name, email,
            country_code: selectCcode,
            phone: number,
            password, gender,
            birth_date: birthdate.format('DD-MM-YYYY'),
            birth_time: birthtime.format(`hh:mm A`),
            birth_place: birthplace,
            language: selectlang
        }

        setApiLoading("Next");
        setUserLogin(prev => prev + 1);


        const Response = await HandleCallApi("Post", "user/signup", ApiData);
        const { ResponseCode, message, customer } = Response.data;

        setIsToast(true);
        setToastMsg(message);
        if (ResponseCode === 200) {
            setIsAuth(true);
            setUserLogin(prev => prev + 1);
            secureLocalStorage.setItem("Logindata", JSON.stringify(customer));
            secureLocalStorage.setItem("Userid", customer.id);
            secureLocalStorage.setItem("isAuthenticated", true);
            navigate("/");
        }
        setApiLoading("");
    }

    const stepTitles = {
        1: { title: t("Enter Your Details"), subtitle: t("Hey there! what is your name?") },
        2: { title: t("Verify OTP"), subtitle: `${t("You will receive a 6 digit code for")} ${t("verification to")} ${number}` },
        3: { title: t("What is your gender?"), subtitle: t("Select your gender to continue") },
        4: { title: t("Birth Details"), subtitle: t("Enter your birth information for accurate predictions") },
        5: { title: t("Select Languages"), subtitle: t("Do you know which languages?") },
    };

    return (
        <div className='auth_bg'>
            <div className='auth_deco_1'></div>
            <div className='auth_deco_2'></div>
            <div className='auth_deco_3'></div>

            <div className='auth_card auth_card_wide'>

                {/* Step Progress Indicator */}
                <div className='auth_steps'>
                    {[1, 2, 3, 4, 5].map((s) => (
                        <div key={s} className='contents'>
                            <div className={`auth_step_circle ${step >= s ? 'active' : 'inactive'}`}>{s}</div>
                            {s < 5 && <div className={`auth_step_line ${step > s ? 'active' : 'inactive'}`}></div>}
                        </div>
                    ))}
                </div>

                {/* Step Title */}
                <div className='text-center mb-8'>
                    <h1 className='text-2xl md:text-3xl font-extrabold text-gray-800 mb-2'>{stepTitles[step]?.title}</h1>
                    <p className='text-gray-500 text-sm'>{stepTitles[step]?.subtitle}</p>
                </div>

                {/* Step 1: Personal Details */}
                {step === 1 && <div>
                    <div className='mb-4'>
                        <label className='auth_label'>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.009 10.75C9.66503 10.75 7.75903 8.843 7.75903 6.5C7.75903 4.157 9.66503 2.25 12.009 2.25C14.353 2.25 16.259 4.157 16.259 6.5C16.259 8.843 14.353 10.75 12.009 10.75ZM12.009 3.75C10.492 3.75 9.25903 4.983 9.25903 6.5C9.25903 8.017 10.492 9.25 12.009 9.25C13.526 9.25 14.759 8.017 14.759 6.5C14.759 4.983 13.525 3.75 12.009 3.75ZM15.9969 21.75H8.00305C5.58305 21.75 4.25 20.425 4.25 18.019C4.25 15.358 5.756 12.25 10 12.25H14C18.244 12.25 19.75 15.357 19.75 18.019C19.75 20.425 18.4169 21.75 15.9969 21.75ZM10 13.75C6.057 13.75 5.75 17.017 5.75 18.019C5.75 19.583 6.42405 20.25 8.00305 20.25H15.9969C17.5759 20.25 18.25 19.583 18.25 18.019C18.25 17.018 17.943 13.75 14 13.75H10Z" fill="currentColor" /></svg>
                            {t("Full Name")}
                        </label>
                        <div className='auth_input_wrap'>
                            <input value={alldata.name} onChange={(e) => setAllData({ ...alldata, name: e.target.value })} placeholder={t('Enter your Full Name')} />
                        </div>
                    </div>

                    <div className='mb-4'>
                        <label className='auth_label'>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 20.75H6C3.582 20.75 2.25 19.418 2.25 17V8C2.25 5.582 3.582 4.25 6 4.25H18C20.418 4.25 21.75 5.582 21.75 8V17C21.75 19.418 20.418 20.75 18 20.75ZM6 5.75C4.423 5.75 3.75 6.423 3.75 8V17C3.75 18.577 4.423 19.25 6 19.25H18C19.577 19.25 20.25 18.577 20.25 17V8C20.25 6.423 19.577 5.75 18 5.75H6ZM13.0291 13.179L17.9409 9.60699C18.2759 9.36399 18.35 8.89401 18.106 8.55901C17.863 8.22501 17.3951 8.149 17.0581 8.394L12.146 11.966C12.058 12.03 11.941 12.03 11.853 11.966L6.94092 8.394C6.60292 8.149 6.13607 8.22601 5.89307 8.55901C5.64907 8.89401 5.72311 9.36299 6.05811 9.60699L10.97 13.18C11.278 13.404 11.639 13.515 11.999 13.515C12.359 13.515 12.7221 13.403 13.0291 13.179Z" fill="currentColor" /></svg>
                            {t("Email Address")}
                        </label>
                        <div className='auth_input_wrap'>
                            <input value={alldata.email} onChange={(e) => setAllData({ ...alldata, email: e.target.value })} placeholder={t('Enter your email')} />
                        </div>
                    </div>

                    <div className='mb-4'>
                        <label className='auth_label'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                            {t("Phone Number")}
                        </label>
                        <div className='relative' ref={ccodeRef}>
                            <div className='auth_input_wrap'>
                                <div onClick={() => setShowCcode(!showCcode)} className='flex items-center gap-1 cursor-pointer text-gray-500 hover:text-gray-700 transition-colors'>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z" fill="currentColor" /></svg>
                                    <span className='text-sm font-medium'>{selectCcode}</span>
                                </div>
                                <div className='w-px h-5 bg-gray-200'></div>
                                <input type="number" value={number} onChange={(e) => setNumber(e.target.value)} placeholder={t('Enter your number')} />
                            </div>
                            {showCcode && <div className='auth_ccode_dropdown'>
                                <input type="number" value={searchCcode} onChange={(e) => setSearchCcode(e.target.value)} placeholder={t("Search")} />
                                <ul>
                                    {FilterCCode.map((item, index) => (
                                        <li key={index} onClick={() => { setSelectCcode(`+${getCountryCallingCode(item)}`); setShowCcode(false); }}>+{getCountryCallingCode(item)}</li>
                                    ))}
                                </ul>
                            </div>}
                        </div>
                    </div>

                    <div className='mb-2'>
                        <label className='auth_label'>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.75 8.30396V7C16.75 4.381 14.619 2.25 12 2.25C9.381 2.25 7.25 4.381 7.25 7V8.30396C5.312 8.56096 4.25 9.846 4.25 12V18C4.25 20.418 5.582 21.75 8 21.75H16C18.418 21.75 19.75 20.418 19.75 18V12C19.75 9.847 18.688 8.56195 16.75 8.30396ZM12 3.75C13.792 3.75 15.25 5.208 15.25 7V8.25H8.75V7C8.75 5.208 10.208 3.75 12 3.75ZM18.25 18C18.25 19.577 17.577 20.25 16 20.25H8C6.423 20.25 5.75 19.577 5.75 18V12C5.75 10.423 6.423 9.75 8 9.75H16C17.577 9.75 18.25 10.423 18.25 12V18ZM13.27 14C13.27 14.412 13.058 14.7601 12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14Z" fill="currentColor" /></svg>
                            {t("Password")}
                        </label>
                        <div className='auth_input_wrap'>
                            <input type={passtype} value={alldata.password} onChange={(e) => setAllData({ ...alldata, password: e.target.value })} placeholder={t('Enter your password')} />
                            <div className='auth_icon_btn' onClick={() => setPassType(passtype === "Password" ? "text" : "Password")}>
                                {passtype === "Password"
                                    ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.229 13.8679C19.913 16.0639 16.96 19.75 12 19.75C11.037 19.75 10.0861 19.604 9.17408 19.315C8.77908 19.19 8.56105 18.769 8.68605 18.374C8.81005 17.978 9.23496 17.762 9.62696 17.885C10.392 18.127 11.19 18.25 12 18.25C16.222 18.25 18.7901 15.02 19.9441 13.094C20.3521 12.418 20.3521 11.581 19.9461 10.907C19.6001 10.324 19.177 9.72798 18.72 9.17898C18.455 8.85998 18.4991 8.38707 18.8181 8.12307C19.1381 7.85807 19.61 7.90199 19.875 8.21999C20.381 8.82899 20.8509 9.49199 21.2329 10.137C21.9259 11.284 21.926 12.7159 21.229 13.8679ZM10.063 14.9981L3.53004 21.531C3.38404 21.677 3.19201 21.751 3.00001 21.751C2.80801 21.751 2.61598 21.678 2.46998 21.531C2.17698 21.238 2.17698 20.763 2.46998 20.47L5.64503 17.2949C4.31703 16.1499 3.35205 14.837 2.76905 13.866C2.07505 12.716 2.07501 11.2841 2.77101 10.1331C4.08701 7.93708 7.04001 4.251 12 4.251C13.835 4.251 15.565 4.76994 17.155 5.78494L20.469 2.47097C20.762 2.17797 21.237 2.17797 21.53 2.47097C21.823 2.76397 21.823 3.23901 21.53 3.53201L10.065 14.9971C10.065 14.9971 10.065 14.9981 10.064 14.9981C10.063 14.9981 10.063 14.9971 10.063 14.9981ZM9.6089 13.3311L13.3311 9.60891C12.9291 9.38191 12.478 9.251 12 9.251C10.484 9.251 9.25099 10.484 9.25099 12.001C9.25099 12.478 9.3829 12.9291 9.6089 13.3311ZM6.70704 16.232L8.51905 14.4199C8.02405 13.7169 7.75099 12.882 7.75099 11.999C7.75099 9.65605 9.65701 7.74905 12 7.74905C12.884 7.74905 13.7179 8.02211 14.4209 8.51711L16.052 6.88601C14.787 6.14501 13.432 5.74807 12 5.74807C7.77801 5.74807 5.20992 8.97808 4.05592 10.9041C3.64792 11.5801 3.64797 12.4171 4.05397 13.0911C4.59097 13.9881 5.48304 15.201 6.70704 16.232ZM14.708 12.4351C14.528 13.5951 13.594 14.53 12.436 14.709C12.027 14.772 11.7461 15.155 11.8091 15.564C11.8671 15.935 12.1861 16.2 12.5491 16.2C12.5871 16.2 12.6261 16.1969 12.6641 16.1909C14.4911 15.9089 15.908 14.4921 16.19 12.6641C16.253 12.2541 15.973 11.8721 15.563 11.8081C15.163 11.7471 14.771 12.0251 14.708 12.4351Z" fill="currentColor" /></svg>
                                    : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.2352 10.1379C19.9222 7.93894 16.9751 4.25 12.0001 4.25C7.02511 4.25 4.07801 7.93894 2.76501 10.1379C2.07801 11.2859 2.07801 12.7131 2.76501 13.8621C4.07801 16.0611 7.02511 19.75 12.0001 19.75C16.9751 19.75 19.9222 16.0611 21.2352 13.8621C21.9222 12.7131 21.9222 11.2869 21.2352 10.1379ZM19.9481 13.092C18.7981 15.018 16.2351 18.25 12.0001 18.25C7.76511 18.25 5.20212 15.019 4.05212 13.092C3.65012 12.418 3.65012 11.581 4.05212 10.907C5.20212 8.98098 7.76511 5.74902 12.0001 5.74902C16.2351 5.74902 18.7981 8.97998 19.9481 10.907C20.3511 11.582 20.3511 12.418 19.9481 13.092ZM12.0001 7.75C9.65611 7.75 7.75011 9.657 7.75011 12C7.75011 14.343 9.65611 16.25 12.0001 16.25C14.3441 16.25 16.2501 14.343 16.2501 12C16.2501 9.657 14.3441 7.75 12.0001 7.75ZM12.0001 14.75C10.4831 14.75 9.25011 13.517 9.25011 12C9.25011 10.483 10.4831 9.25 12.0001 9.25C13.5171 9.25 14.7501 10.483 14.7501 12C14.7501 13.517 13.5171 14.75 12.0001 14.75Z" fill="currentColor" /></svg>
                                }
                            </div>
                        </div>
                    </div>
                </div>}

                {/* Step 2: OTP Verification */}
                {step === 2 && <div>
                    <div className='flex items-center justify-center gap-3'>
                        {otpfiled.map((value, index) => (
                            <input type="text"
                                key={index}
                                value={value}
                                ref={(e) => OtpRef.current[index] = e}
                                onChange={(e) => handleOnChnage(e.target.value, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                className="auth_otp_input"
                                maxLength="1"
                            />
                        ))}
                    </div>
                </div>}

                {/* Step 3: Gender Selection */}
                {step === 3 && <div>
                    <div className='grid grid-cols-2 gap-4'>
                        {GenderList.map((item, index) => {
                            const IsSelected = item.title === alldata.gender;
                            return <div onClick={() => setAllData({ ...alldata, gender: item.title })} key={index} className={`auth_gender_card ${IsSelected ? 'selected' : ''}`}>
                                <div className='img_box'>
                                    <img src={item.icon} className='w-[28px]' alt={`Icon ${t(item.title)}`} />
                                </div>
                                <h1 className='text-sm font-semibold text-gray-700 mt-1'>{t(item.title)}</h1>
                            </div>
                        })}
                    </div>
                </div>}

                {/* Step 4: Birth Details */}
                {step === 4 && <div>
                    <div className='mb-4'>
                        <label className='auth_label'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line></svg>
                            {t("Enter your birth date")}
                        </label>
                        <div onClick={() => setIsDate(true)} className='auth_input_wrap cursor-pointer'>
                            <span className='font-medium text-gray-700 text-sm'>{alldata.birthdate.format('YYYY-MM-DD')}</span>
                        </div>
                    </div>
                    <div className='mb-4'>
                        <label className='auth_label'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            {t("Enter your birth time")}
                        </label>
                        <div onClick={() => setIsTime(true)} className='auth_input_wrap cursor-pointer'>
                            <span className='font-medium text-gray-700 text-sm'>{alldata.birthtime.format('hh:mm A')}</span>
                        </div>
                    </div>
                    <div>
                        <label className='auth_label'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                            {t("Enter your birth Place")}
                        </label>
                        <div className='auth_input_wrap'>
                            <input type="text" value={alldata.birthplace} onChange={(e) => setAllData({ ...alldata, birthplace: e.target.value })} placeholder={t('Enter Your Place')} />
                        </div>
                    </div>
                </div>}

                {/* Step 5: Language Selection */}
                {step === 5 && <div>
                    <div className='auth_input_wrap mb-4'>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='auth_icon'><path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="currentColor" /></svg>
                        <input type="text" value={searchlang} onChange={(e) => setSearchLang(e.target.value)} placeholder={t('Search')} />
                    </div>

                    <div className='max-h-[280px] overflow-y-auto scroll_container'>
                        {FilterLang.map((item, index) => {
                            const IsSelected = selectlang.includes(item.id);
                            return <div onClick={() => handleSelectLanguage(item.id)} key={index} className={`auth_lang_item ${IsSelected ? 'selected' : ''}`}>
                                <h1 className='text-gray-700 font-medium text-sm'>{item.title}</h1>
                                {IsSelected && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="#f97316" /></svg>}
                            </div>
                        })}
                    </div>
                </div>}

                {/* Next / Submit Button */}
                <button onClick={handleNext}
                    className={`auth_btn_primary mt-6 ${apiloading === "Next" ? "opacity-60" : ""}`}
                    disabled={apiloading === "Next"}
                >
                    {apiloading === "Next" ? <Btn_loader CustomeStyle={"bg-white"} /> : step === 5 ? t("Sign Up") : t("Next")}
                </button>

                {/* Back Navigation */}
                <div className='flex items-center justify-center mt-6'>
                    {step === 1
                        ? <Link to="/auth/login" className='flex items-center gap-2 group'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className='text-orange-500 group-hover:text-gray-700 transition-colors' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="m12 19-7-7 7-7"></path>
                                <path d="M19 12H5"></path>
                            </svg>
                            <span className='font-semibold text-sm text-orange-500 group-hover:text-gray-700 transition-colors'>{t("Back to Login")}</span>
                        </Link>
                        : <button onClick={() => setStep(prev => (smsType === "No Auth" && prev === 3) ? 1 : prev - 1)} className='flex items-center gap-2 group'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className='text-orange-500 group-hover:text-gray-700 transition-colors' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="m12 19-7-7 7-7"></path>
                                <path d="M19 12H5"></path>
                            </svg>
                            <span className='font-semibold text-sm text-orange-500 group-hover:text-gray-700 transition-colors'>{t("Back")}</span>
                        </button>}
                </div>

            </div>

            {/* Date Picker Modal */}
            {isdate && <div onClick={() => setIsDate(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()}>
                    <DatePicker value={alldata.birthdate} setIsDate={setIsDate} handleDateChange={handleDateChange} />
                </div>
            </div>}

            {/* Time Picker Modal */}
            {istime && <div onClick={() => setIsTime(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()}>
                    <TimePicker value={alldata.birthtime} setIsTime={setIsTime} handleTimeSelect={handleTimeSelect} />
                </div>
            </div>}

        </div>
    )
}

export default Signup